import React, { useEffect } from 'react';
import {Card, CardBody, CardTitle } from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { connect } from 'react-redux'

import HarborFilters from "./_filters";
import { confirmAlert } from 'react-confirm-alert';
import {ButtonTableDelete, ButtonTableEdit, } from "../../../components/buttons/buttonsActions";
import TranslateButton from "../../../components/buttons/TranslateButton";
import { showLoader } from "../../../components/loader/loader";
import {
	ARE_YOU_SHURE_MSG, ARE_YOU_SHURE_TITLE, LIST, NO, NO_DATA_FOUND,
	YES, LB_CODE, LB_NAME, LB_ACTIONS
} from "../../../components/i18n/i18n";

import { setFormInfo } from '../../../redux/actions/genericActions'
import { searchHarbors, deleteHarbor } from '../../../redux/actions/harborActions'
import { setTableInfo, changeLoadDataStatus } from "../../../redux/actions/filterActions";
import { harborService } from "../../../jwt/_services/xailing/harborService";
import TranslateItem from "../../../components/genericComponents/translateItem";

const HarborList = props => {
	const fbDataBaseId = props?.app?.fbDataBase?.id
	const { loadData, page, sizePerPage, totalSize, currentIndex, filterInfo, listItems} = props.filterInfo
	const { loading } = props.genericInfo

	//Cargar los datos
	useEffect(() => {
		if(!loadData)
			return

		refreshDataList()

		return () => props.changeLoadDataStatus(false)
	}, [filterInfo, page, sizePerPage]);

	const refreshDataList =  () => props.searchHarbors(page, currentIndex, sizePerPage, filterInfo)

	const handleTableChange = (type, {page, sizePerPage}) => {
		let currentIndex = (page - 1) * sizePerPage
		props.setTableInfo({ page, sizePerPage, currentIndex })
	};

	const confirmDelete = (data) => {
		return confirmAlert({
			closeOnEscape: true,
			closeOnClickOutside: true,
			customUI: ({onClose}) => {
				return (
					<div className='custom-ui'>
						<h1>{ARE_YOU_SHURE_TITLE}</h1>
						<p>{ARE_YOU_SHURE_MSG}</p>
						<button onClick={onClose}>{NO}</button>
						<button className={"btn-alert-delete"} onClick={() => {
							props.deleteHarbor(data.id, fbDataBaseId)
							onClose();
						}}>
							{YES}
						</button>
					</div>
				);
			}
		});
	};

	const actionsFormatter = (cell, row) => <>
		<ButtonTableEdit onClick={() => props.setFormInfo(true, row, 'FORM')}/>
		<TranslateButton item={row} service={harborService} />
		<ButtonTableDelete onClick={() => confirmDelete(row)}/>
	</>

	const columns = [
		{
			dataField: 'id',
			text: 'ID',
			hidden: true
		}, {
			dataField: 'code',
			text: `${LB_CODE}`,
			headerStyle: {width: '120px'},
			sort: true
		}, {
			dataField: 'name',
			text: `${LB_NAME}`,
			sort: true
		}, {
			dataField: 'actions',
			isDummyField: true,
			text: `${LB_ACTIONS}`,
			headerAlign: 'center',
			align: 'center',
			headerStyle: {width: '200px'},
			formatter: actionsFormatter
		}
	];

	return (<>
		{loading && showLoader()}
		<Card>
			<CardTitle className="bg-light border-bottom p-3 mb-0">
				<i className="far fa-list-alt mr-2"> </i>
				{LIST}
			</CardTitle>

			<HarborFilters />

			<CardBody className="">
				<BootstrapTable
					striped hover
					tableHeaderClass='mb-0'
					remote
					keyField="id"
					data={ listItems || [] }
					columns={columns}
					noDataIndication={NO_DATA_FOUND}
					pagination={ paginationFactory({ page, sizePerPage, totalSize })}
					onTableChange={handleTableChange}
				/>
			</CardBody>
		</Card>
	</>)
}

const mapStateToProps = state => ({
	genericInfo: state.genericInfo,
	filterInfo: state.filter
})

const mapActionsToProps = ({
	setFormInfo,
	setTableInfo,
	changeLoadDataStatus,
	searchHarbors,
	deleteHarbor,
})

export default connect(mapStateToProps, mapActionsToProps)(HarborList)